const STATUS_BADGE_MAP = {
  pending: 'bg-warning-subtle text-warning',
  approved: 'bg-success-subtle text-success',
  paid: 'bg-info-subtle text-info',
  cancelled: 'bg-secondary-subtle text-secondary',
};

const TYPE_BADGE_MAP = {
  cpa: 'bg-primary-subtle text-primary',
  lot_rebate: 'bg-info-subtle text-info',
};

export function getCommissionStatusBadgeClass(status) {
  const normalized = String(status || '').trim().toLowerCase();
  return STATUS_BADGE_MAP[normalized] || 'bg-secondary-subtle text-secondary';
}

export function getCommissionTypeBadgeClass(type) {
  const normalized = String(type || '').trim().toLowerCase();
  return TYPE_BADGE_MAP[normalized] || 'bg-secondary-subtle text-secondary';
}

export function isCommissionActionable(status) {
  return String(status || '').trim().toLowerCase() === 'pending';
}
